export default [
    {
         path: '/cost',
         // which is lazy-loaded when the route is visited.
         component: () => import( '@/views/loud/cost/cost.vue'),
    },
    {
         path: '/cost/BscCostDetail',
         // which is lazy-loaded when the route is visited.
         component: () => import( '@/views/loud/cost/BscCostDetail.vue'),
        meta: {
            title: '费用使用记录',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
         path: '/cost/Detail',
         // which is lazy-loaded when the route is visited.
         component: () => import( '@/views/loud/cost/Detail.vue'),
    }
]
